














































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class GlobalResults extends Vue {
  @Prop(String) tokenType!: string;
  @Prop({ type: Array, default: null }) readonly results!: Array<{
    address: string;
    items: number;
    points: number;
  }>;

  galaIcon = require(`@/assets/icons/icon_gala_cube.png`);
  pointsIcon = require('@/assets/icons/icon_node_fire.png');
  townIcon = require('@/assets/icons/my-nodes/TownStars_Icon@3x.png');
}
